import { Maybe, TrackedPropertyRelationship } from '../../graphql.generated';
import { getBaseLayer } from '@zoopla/tracking';
import type { PropertyDataForAnalytics } from '../getPropertyDataForAnalytics';

export const triggerSegmentPropertyEvent = async (
    analyticsData: PropertyDataForAnalytics,
    eventName: string,
    relationship?: Maybe<TrackedPropertyRelationship> | 'undefined',
    page = '/property/details/'
): Promise<void> => {
    const baselayer = getBaseLayer();
    const taxonomy = {
        page,
        uprn: analyticsData.uprn,
        property_num_beds: analyticsData.numberBeds,
        price_estimate: analyticsData.priceEstimate,
        rental_estimate: analyticsData.rentalEstimate,
        postcode: analyticsData.postcode,
        property_address: analyticsData.propertyAddress,
        listing_id: analyticsData.listingId,
        display_address: analyticsData.displayAddress,
        price: analyticsData.rent ? null : analyticsData.price,
        rent: analyticsData.rent,
        num_beds: analyticsData.numBeds,
        ...(typeof relationship !== undefined && {
            property_relationship: relationship?.toLowerCase()
        })
    };

    if (typeof window.analytics !== 'undefined') {
        window.analytics.ready(() => {
            const traits = window.analytics?.user().traits();
            window.analytics?.track(
                eventName,
                { baselayer, taxonomy },
                { traits }
            );
        });
    }
};
